import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LearningHubBreadcrumb, LearningHubLanguage } from '../../definitions/learning-hub.models';

/** Learning Hub › Section › Subsection; the last item is the current page (no link). */
@Component({
  selector: 'app-learning-hub-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbComponent {
  @Input() items: LearningHubBreadcrumb[] = [];
  @Input() lang: LearningHubLanguage;
}
